const initialState = {
    betsHistory: ''
}

export default function (state = initialState, action) {
    switch (action.type) {
        case 'BETS_HISTORY':
            return { ...state, betsHistory: action.payload }                                    
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/betsReducer.js